import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    projectsAdminControllerListProjectsV1: build.query<
      ProjectsAdminControllerListProjectsV1ApiResponse,
      ProjectsAdminControllerListProjectsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/projects` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type ProjectsAdminControllerListProjectsV1ApiResponse =
  /** status 200 Telegram group → project/account mapping, keyed by Telegram chat id */ ListProjectsResponse;
export type ProjectsAdminControllerListProjectsV1ApiArg = void;
export type ListProjectsResponse = {
  /** One entry per Telegram group MM Client knows about */
  data: {
    /** Telegram chat id, negative for groups and supergroups. Matches chatId on GET /admin/telegram-groups. */
    chatId: string;
    /** Trading accounts in the group. Empty if MM Client reports none. */
    accounts: {
      /** MM Client trading account id */
      accountId: number;
      /** Whether the account's exchange API is enabled. Disabled accounts are still listed. */
      isActive: boolean;
      /** Project this account is linked to, or null when it is not linked. The value is a composite (project type * 1000000 + id); only the whole number is unique. */
      projectId: null | number;
    }[];
    /** Distinct projects behind those accounts. Empty when every account is unlinked. */
    projects: {
      /** Composite project id (project type * 1000000 + id), matching an account projectId. Group by this whole value, never by its parts. */
      id: number;
      /** Human-readable project name */
      name: string;
    }[];
  }[];
};
